import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * Horizontal row of pill buttons for single-select filtering; highlights the active selection.
 */
@Component({
  selector: 'es-filter-chips',
  template: `
    <div class="flex items-center gap-1">
      @for (option of options; track option) {
        <button
          class="px-3 py-1 rounded-full text-xs font-medium transition-colors cursor-pointer"
          [class]="option === selected
            ? 'bg-echo-blue/15 text-echo-blue'
            : 'text-[var(--text-secondary)] hover:bg-[var(--bg-card-hover)]'"
          (click)="selectionChange.emit(option)"
        >{{ option }}</button>
      }
    </div>
  `,
})
export class FilterChipsComponent {
  @Input() options: string[] = [];
  @Input() selected = '';
  @Output() selectionChange = new EventEmitter<string>();
}
